'use es6';

import { Component } from 'react';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { closeCloneRequestModal as closeCloneRequestModalAction } from 'ContentEditorUI/redux/actions/moduleActions';
import { getActionForCloneRequest, getTypeForCloneRequest } from 'ContentEditorUI/redux/selectors/cloneRequestSelectors';
import { getIsAdvancedPageTemplate } from 'ContentEditorUI/redux/selectors/templateInfoSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => ({
  actionForClone: getActionForCloneRequest(state),
  isAdvancedTemplate: getIsAdvancedPageTemplate(state),
  typeForClone: getTypeForCloneRequest(state)
});
const mapDispatchToProps = dispatch => ({
  dispatch,
  closeCloneRequestModal: () => dispatch(closeCloneRequestModalAction())
});

/**
 * @param {Object} props
 * @param {Object} [props.actionForClone] (optional)
 * @param {Function} props.closeCloneRequestModal (required)
 * @param {Function} [props.dispatch] (optional)
 * @param {boolean} [props.isAdvancedTemplate] (optional)
 * @param {string} [props.typeForClone] (optional)
 */
class CloneRequestModalContainer extends Component {
  constructor(props) {
    super(props);
    this.handleCancelClone = this.handleCancelClone.bind(this);
    this.handleConfirmClone = this.handleConfirmClone.bind(this);
  }
  handleCancelClone() {
    this.props.closeCloneRequestModal();
  }
  handleConfirmClone() {
    const {
      actionForClone,
      closeCloneRequestModal,
      dispatch
    } = this.props;
    if (actionForClone) {
      dispatch(actionForClone);
      closeCloneRequestModal();
    }
  }
  render() {
    const {
      actionForClone,
      isAdvancedTemplate,
      typeForClone
    } = this.props;
    if (!actionForClone) {
      return null;
    }
    const cloneModalDialogKey = isAdvancedTemplate ? `app.layoutSection.cloneDialogBody.${typeForClone}` : `app.layoutSection.cloneDialogBody.simpleTemplate.${typeForClone}`;
    return /*#__PURE__*/_jsx(ConfirmModal, {
      confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.layoutSection.cloneDialogConfirmButton"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: cloneModalDialogKey
      }),
      rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.layoutSection.cloneDialogRejectButton"
      }),
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.layoutSection.cloneDialogTitle"
      }),
      onConfirm: this.handleConfirmClone,
      onReject: this.handleCancelClone
    });
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(CloneRequestModalContainer);